<template>
    <div class="other-products-container">

        <h4 class="font-21 noto-semibold products-title" v-if="_.get(itemData, 'conf.header.title')">{{_.get(itemData, 'conf.header.title')}}</h4>

        <template v-for="(slide, index) in itemData.data" >
        <div class="app-link-box product-box br-12" :key="index">
            <div class="img-box">
                <picture>
                    <source
                            media="(max-width: 767px)"
                            :srcset="_.get(slide, 'hover_image') == undefined ? _.get(slide, 'images.0.devices.mobile') :_.get(slide, 'hover_image.0.devices.mobile')"
                    />
                    <source
                            media="(max-width: 1023px)"
                            :srcset="_.get(slide, 'hover_image') == undefined ? _.get(slide, 'images.0.devices.tablet') :_.get(slide, 'hover_image.0.devices.tablet')"
                    />
                    <img
                            :src="_.get(slide, 'hover_image') == undefined ? _.get(slide, 'images.0.devices.desktop') :_.get(slide, 'hover_image.0.devices.desktop')"
                            class="img-absolute br-12"
                            alt
                    />
                </picture>
<!--                <img v-if="_.get(slide, 'images.0.url')" :src="_.get(slide, 'images.0.url')" alt="" class="img-absolute br-12">-->
                <div class="gradient br-12"></div>
                <div class="box-content">
                    <h3 class="white font-34 noto-semibold">{{slide.title}}</h3>
                    <p class="white">{{slide.teaser}}</p>
                </div>

                <SmartButton :cssclass="'btn sub bg-white'" :itemData="_.get(slide, 'smartbuttons.0')" v-if="_.get(slide, 'smartbuttons.0')" />

            </div>
        </div>
        </template>

    </div>
</template>

<script>
    import SmartButton from "./modules/SmartButton";

    export default {
        props: ["itemData", "titleData", "noBg"],
        components: { SmartButton },

        data() {
            return {
                swiperOptions: {
                    speed: 800,
                    watchOverflow: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    breakpoints: {
                        320: {
                            spaceBetween: 10,
                            slidesPerView: 1,
                        },
                        768: {
                            spaceBetween: 20,
                            slidesPerView: 1.5,
                        },
                    },
                },
            };
        },

        computed: {
            getItemReasonsSlider() {
                return this.$store.getters.getItemReasonsSlider;
            },
            swiper() {
                return this.$refs.productSlider.$swiper;
            },
        },
    };
</script>
